// Get Documents
export const GET_DOCUMENTS = "GET_DOCUMENTS"
export const GET_DOCUMENTS_SUCCESS = "GET_DOCUMENTS_SUCCESS"
export const GET_DOCUMENTS_FAIL = "GET_DOCUMENTS_FAIL"

// Get Document By Id
export const GET_DOCUMENT_BY_ID = "GET_DOCUMENT_BY_ID"
export const GET_DOCUMENT_BY_ID_SUCCESS = "GET_DOCUMENT_BY_ID_SUCCESS"
export const GET_DOCUMENT_BY_ID_FAIL = "GET_DOCUMENT_BY_ID_FAIL"

// Add Document
export const ADD_DOCUMENT = "ADD_DOCUMENT"
export const ADD_DOCUMENT_SUCCESS = "ADD_DOCUMENT_SUCCESS"
export const ADD_DOCUMENT_FAIL = "ADD_DOCUMENT_FAIL"

// Delete Document
export const DELETE_DOCUMENT = "DELETE_DOCUMENT"
export const DELETE_DOCUMENT_SUCCESS = "DELETE_DOCUMENT_SUCCESS"
export const DELETE_DOCUMENT_FAIL = "DELETE_DOCUMENT_FAIL"

// Clear Documents
export const CLEAR_DOCUMENTS = "CLEAR_DOCUMENTS"

// Reset Flag
export const RESET_DOCUMENT_FLAG = "RESET_DOCUMENT_FLAG"
